module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "more",
    on: {
      "click": function($event) {
        return _vm.$emit('more')
      }
    }
  }, [_vm._t("default", [_vm._v("Подробнее")])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71f11055","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/competences/card/components/btn/Button.vue
// module id = 55eea1f1011cf3851590
// module chunks = 0